export { default as CompanyOperationsCompactTableRow } from './CompanyOperationsCompactTableRow';
